import { CROSSWORD_RANKS, CrosswordRank } from "./crosswordGame.ts";

/*
 * The one thing the Baker Street Math Crossword keeps besides the best scores (ADR 0134
 * §6): the rank last chosen, so the page opens on it. The scores live with every other
 * game's in bestScore.ts. Same read-validate / try-write habit as shopStore.ts: nothing
 * leaves the browser, and a full or disabled store costs nothing but the memory.
 */
const STORAGE_KEY = "mathpages.crosswordGame";

/** The page opens on Constable until a rank has been chosen. */
export const DEFAULT_CROSSWORD_RANK: CrosswordRank = "constable";

export function readCrosswordRank(): CrosswordRank {
    try {
        const stored = window.localStorage.getItem(STORAGE_KEY);
        const parsed = stored ? JSON.parse(stored) : null;
        if (parsed && typeof parsed === "object" && CROSSWORD_RANKS.includes(parsed.rank)) {
            return parsed.rank;
        }
    } catch {
        // Unavailable or unreadable: the default.
    }
    return DEFAULT_CROSSWORD_RANK;
}

export function saveCrosswordRank(rank: CrosswordRank): void {
    try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ rank }));
    } catch {
        // Full, disabled, or unavailable. A rank is not worth an error.
    }
}
